import { useEffect } from 'react';
import { TrackingApi } from 'src/api';
import { SessionSourceType } from 'src/api/learningSessions/types';
import type { CardData } from 'src/apps/LearningSession/Common/learnableCards/utils';

type UseTrackCardScreenViewArgs = {
  cardData: CardData;
  languagePairId: number;
  isPro: boolean;
  sessionSourceType: SessionSourceType;
  sessionSourceId: number;
  videoSrc: string | null;
  videoActorIds: number[] | null;
  extraTrackingData?: Record<string, string>;
};

export const useTrackCardScreenView = ({
  cardData,
  languagePairId,
  isPro,
  sessionSourceType,
  sessionSourceId,
  videoSrc,
  videoActorIds,
  extraTrackingData,
}: UseTrackCardScreenViewArgs) => {
  useEffect(() => {
    const trackingData: Record<string, string> = {
      page_screen_type: 'Learning session',
      page_screen_name: cardData.kind === 'Presentation' ? 'Presentation card' : 'Test card',
      session_source_type: sessionSourceType,
      session_source_id: String(sessionSourceId),
      ...(videoSrc && { video_src: videoSrc }),
      ...(videoActorIds?.length && { actor_ids: videoActorIds.join(',') }),
      ...extraTrackingData,
    };

    if (cardData.kind === 'Presentation') {
      trackingData.nugget_available = cardData.nugget ? 'true' : 'false';
    }

    void TrackingApi.trackUserAction(
      'screen_viewed',
      'learning_session',
      languagePairId,
      isPro,
      trackingData,
    );
  }, [
    languagePairId,
    isPro,
    sessionSourceType,
    sessionSourceId,
    cardData,
    videoSrc,
    videoActorIds,
    extraTrackingData,
  ]);
};
